/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.user.context.rpc.PlanProgressRpc
 */

export const getPortalGuidesRpc = {
  serviceName: 'com.hubspot.user.context.rpc.PlanProgressRpc',
  rpcName: 'getPortalGuides',
  auth: 'app',
  fingerprint: 'LQJT-3eLvmiFwnEQc5aXfU5M21HIk3eQ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPortalGuideDetailsRpc = {
  serviceName: 'com.hubspot.user.context.rpc.PlanProgressRpc',
  rpcName: 'getPortalGuideDetails',
  auth: 'app',
  fingerprint: 'zDKp7HiydMTNYKSDVIYhLE5M21HIk3eQ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};